import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://ftdyqvsycztvqfjjwhgw.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ0ZHlxdnN5Y3p0dnFmamp3aGd3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI2MzI3ODEsImV4cCI6MjA0ODIwODc4MX0.zTmRIc_97dJYOIVlpRYcRx96OXn_5p7PcQpy_gyNT5M'

export const supabase = createClient(supabaseUrl, supabaseKey) 